import { Button } from "@mui/material";
import moment from "moment";
import React from "react";
import SingleSelectAutocomplete from "../../../components/AutoComplete/AutoComplete";

export const CancelSubscriptionDetails = ({
  employee,
  loadingButton,
  rowData,
  setEmployee,
  employeeArray,
  handleChangeStatus,
}) => {
  return (
    <form>
      <>
        <h5>Subscriptions Details</h5>
        <div className="d-flex justify-content-between align-items-center mt-3 border-bottom">
          <p className="mb-2">Package:</p>
          <div className="text-muted text-end">
            <div className="text-muted">
              ${rowData?.product_info?.amount} /{" "}
              {rowData?.product_info?.interval_type}
            </div>
            <div>{rowData?.product_info?.title || "_ _"}</div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3 border-bottom">
          <p className="mb-0">Date:</p>
          <p className="mb-0 text-muted">
            {rowData?.cancel_request_date
              ? moment(rowData.cancel_request_date).format("DD MMM YY hh:mm A")
              : "_ _"}
          </p>
        </div>

        {/* <div className="d-flex justify-content-between align-items-center mt-3 border-bottom">
        <p className="mb-0">Package Price:</p>
        <p className="mb-0 text-muted">
          ${rowData?.product_price || "0"}
        </p>
      </div> */}

        {rowData?.cancel_request !== "canceled" && (
          <div className="my-3 mt-4">
            <SingleSelectAutocomplete
              inputLabel="Approve By"
              selectedOption={employee}
              setSelectedOption={setEmployee}
              optionsList={employeeArray}
              required={true}
              name="name"
              size="medium"
            />
          </div>
        )}
      </>
      <div className="col-12 text-end mt-3 mb-2">
        {/* <Button
        variant="contained"
        className="me-2"
        disabled={!employee || loadingButton}
        onClick={() => handleChangeStatus("rejected")}
      >
        Reject
      </Button> */}
        {rowData?.cancel_request !== "canceled" && (
          <Button
            variant="contained"
            className=""
            disabled={!employee || loadingButton}
            onClick={() => handleChangeStatus("approved")}
          >
            {loadingButton ? "Please Wait..." : "Approve"}
          </Button>
        )}
      </div>
    </form>
  );
};
